<template>
  <v-dialog v-model="dialog" max-width="500px" content-class="confirm-dialog">
    <v-card>
      <v-card-text>
        <h4 v-html="contentText"></h4>
      </v-card-text>
      <v-card-actions>
        <v-btn ref="cancel" depressed rounded @click="cancel"> 취소 </v-btn>
        <v-btn ref="confirm" color="primary" depressed rounded @click="ok"> 확인 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      contentText: "",
    };
  },
  methods: {
    open(_content) {
      this.contentText = _content;
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    ok() {
      this.dialog = false;
      this.$emit("clickOk");
    },
  },
};
</script>

<style lang="scss">
.v-dialog.confirm-dialog {
  .v-card {
    padding: 0;
    .v-card__text {
      padding: 30px 20px;
      color: #000;
      h4 {
        font-size: 1.2rem;
        font-weight: 500;
      }
    }
    .v-card__actions {
      padding: 1rem 0 0;
      justify-content: flex-end;
      .v-btn.v-btn {
        font-size: 1rem;
        width: 50%;
        margin-left: 0;
        border-radius: 0 0 0 32px;
        height: 56px;
        &:last-child {
          border-radius: 0 0 32px 0;
        }
      }
    }
  }
}
</style>
